{
  "pending": "Väntar på godkännande",
  "incomplete": "Ofullständig",
  "registered": "Registrerad",
  "deactivated": "Avaktiverad"
}
